export const ALLOCATION_TYPES = {
  MANUAL: 'manual',
  AUTO: 'auto',
} as const
